import React from 'react';
import PropTypes from 'prop-types';
import * as S from './Link.styles';
import Icon from '../Icon/Icon';

const Link = ({ children, href, size, target, variant, icons, onClick }) => {
  const renderIcon = (name) => {
    const iconSizes = {
      sm: 20,
      md: 24,
    };

    return (
      <Icon
        cursor='pointer'
        name={name}
        width={iconSizes[size]}
        height={iconSizes[size]}
        variant={variant === 'primary' ? 'primary' : 'neutral'}
        modifier={variant === 'primary' ? 'weak' : 'inverted'}
      />
    );
  };

  return (
    <S.Link
      href={href}
      icons={icons}
      size={size}
      target={target}
      variant={variant}
      onClick={onClick}
    >
      <S.HyperlinkContent>
        {icons?.iconLeft && renderIcon(icons.iconLeft)}
        {children}
        {icons?.iconRight && renderIcon(icons.iconRight)}
      </S.HyperlinkContent>
    </S.Link>
  );
};

Link.defaultProps = {
  size: 'sm',
  target: '_self',
  variant: 'primary',
};

Link.propTypes = {
  href: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top', 'framename']),
  variant: PropTypes.oneOf(['primary', 'inverted']),
  icons: PropTypes.shape({
    iconLeft: PropTypes.string,
    iconRight: PropTypes.string,
    iconCenter: PropTypes.string,
  }),
  onClick: PropTypes.func,
};

export default Link;
